import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import { ChangeEvent, ChangeEventHandler, ReactElement } from 'react';
import { ItemWithLabel } from '../utils';
import FieldWrapper, { FieldWrapperProps } from './FieldWrapper';

export default function CheckboxGroupField({
  name,
  onBlur,
  onChange,
  options,
  value,
  ...rest
}: CheckboxGroupProps) {
  function changeState(
    optionValue: string,
    event: ChangeEvent<HTMLInputElement>,
  ) {
    const isEnabled = event.target.checked;

    const newValue = toggleArrayItem(value, optionValue, isEnabled);

    onChange?.({
      ...event,
      target: {
        ...event.target,
        name,
        value: newValue,
      } as any,
    });
  }

  return (
    <FieldWrapper {...rest}>
      <FormGroup>
        {options.map((option) => (
          <FormControlLabel
            control={
              <Checkbox
                checked={value && value.includes(option.value)}
                name={name}
                onBlur={onBlur}
                onChange={(e) => changeState(option.value, e)}
              />
            }
            key={option.value}
            label={option.label as ReactElement}
            value={option.value}
          />
        ))}
      </FormGroup>
    </FieldWrapper>
  );
}

function toggleArrayItem(
  sourceArray: string[] | undefined,
  item: string,
  isAppending: boolean,
): string[] {
  const set = new Set(sourceArray);

  if (isAppending) {
    set.add(item);
  } else {
    set.delete(item);
  }

  // eslint-disable-next-line unicorn/prefer-spread
  return Array.from(set);
}

export interface CheckboxGroupProps extends Omit<
  FieldWrapperProps,
  'onChange'
> {
  name?: string;
  onBlur?: ChangeEventHandler;
  onChange?: ChangeEventHandler;
  options: ItemWithLabel[];
  value?: string[];
}
